export default __webpack_public_path__ + "static/media/wood.a6b60ff4.jpg";